// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"773":"428027cc","2525":"63843350","4121":"63843350","4956":"63843350","9419":"63843350"}[chunkId] + ".chunk.css";
};